import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  createUser,
  updateUser,
} from './../../ducks/users';
import AdminPageShell from '../../components/admin/AdminPageShell';

export class User extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    createUser: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    centers: PropTypes.array.isRequired,
  };
  constructor(props) {
    super(props);

    const { id } = this.props.match.params;
    let userModel;

    if (id) {
      userModel = this.props.users.find(i => i.id === id - 0);
    }

    this.state = Object.assign(
      {},
      id
        ? {
          ...userModel,
          sportComplexIds: userModel.sportComplexIds,
        }
        : {
          id,
          login: '',
          role: '',
          name: '',
          lastname: '',
          post: '',
          phone: '',
          email: '',
          sportComplexIds: [],
        },
      {
        saveEnable: false,
        password: '',
        sportCenterOptions: [],
      }
    );

    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    this.setSportCenterOptions(this.props.centers);
  }

  setSportCenterOptions = sportCenters => this.setState({
    sportCenterOptions: sportCenters.map(center => ({
      value: center.id,
      label: center.name,
    })),
  });

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    }, () => {
      this.setState({ saveEnable: this.validate() });
    });
  }

  handleSelect(value, name) {
    this.setState({
      [name]: value,
    }, () => {
      this.setState({ saveEnable: this.validate() });
    });
  }

  async submit() {
    if (this.validate()) {
      const { sportComplexIds, ...user } = { ...this.state };
      if (user.role === 'moderator') {
        user.sportComplexIds = sportComplexIds;
      }

      if (this.state.id) {
        await this.props.updateUser(user);
      } else {
        await this.props.createUser(user);
      }
    } else {
      alert('Заполните необходимые поля'); // eslint-disable-line no-console
    }

    this.props.history.push('/users');
  }

  validate() {
    const {
      login, password, name, sportComplexIds, role, id,
    } = this.state;

    // для новых пользователей обязательен пароль
    if (!id) {
      if (!(login && password && role)) {
        return false;
      }

      if (login.length <= 0 || password.length <= 0 || password.length <= 0) {
        return false;
      }
    }

    if (role === 'moderator') {
      return sportComplexIds && sportComplexIds.length && name;
    }

    return true;
  }

  render() {
    const { classes } = this.props;
    const { sportCenterOptions } = this.state;
    return (
      <AdminPageShell
        title={this.state.id ? 'Редактирование пользователя' : 'Новый пользователь'}
        actions={
          this.state.role !== 'mobile' ? (
            <Button
              disabled={!this.state.saveEnable}
              variant="contained"
              color="primary"
              onClick={this.submit}
              className={classes.button}
            >
              {this.state.id ? 'Сохранить' : 'Создать'}
            </Button>
          ) : null
        }
      >
      <div className={classes.pageBody}>
        <Paper className={classes.paper} elevation={2}>
          <TextField
            required
            name="login"
            value={this.state.login}
            label="Логин"
            disabled={!!this.state.id}
            className={classes.field}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            required
            name="password"
            value={this.state.password}
            label="Пароль"
            type="password"
            className={classes.field}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            required
            name="name"
            value={this.state.name}
            label="Имя"
            className={classes.field}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            required
            name="lastname"
            value={this.state.lastname}
            label="Фамилия"
            className={classes.field}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            name="phone"
            value={this.state.phone}
            label="Телефон"
            className={classes.field}
            onChange={this.handleChange}
            fullWidth
          />
          {this.state.role === 'moderator' && (
            <>
              <Select
                required
                className={classes.field}
                name="sportComplexIds"
                value={this.state.sportComplexIds}
                multi
                options={sportCenterOptions}
                onChange={selected => this.handleSelect(selected.map(item => item.value), 'sportComplexIds')}
                clearable={false}
                placeholder="Спортивный центр *"
                noResultsText="Не найдено"
              />
              <TextField
                name="post"
                value={this.state.post}
                label="Должность"
                className={classes.field}
                onChange={this.handleChange}
                fullWidth
              />
            </>
          )}
          { this.state.role !== 'mobile' &&
            <FormControl component="fieldset" required className={classes.radioSet}>
              <RadioGroup
                name="role"
                value={this.state.role ? this.state.role : ''}
                className={classes.radioGroup}
                onChange={this.handleChange}
              >
                <FormControlLabel value="administrator" control={<Radio />} label="Администратор" />
                <FormControlLabel value="moderator" control={<Radio />} label="Менеджер" />
                {/* <FormControlLabel value="mobile" control={<Radio />} label="Пользователь" /> */}
              </RadioGroup>
            </FormControl>
          }
        </Paper>
      </div>
      </AdminPageShell>
    );
  }
}

const styles = (theme) => ({
  button: {
    borderRadius: 8,
    padding: theme.spacing(1.25, 3),
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
    '&:disabled': {
      opacity: 0.6,
    },
  },
  paper: {
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: 960,
    alignItems: 'stretch',
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  paperImages: {
    overflowX: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: 960,
    alignItems: 'stretch',
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  pageBody: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    minHeight: 0,
  },
  field: {
    marginLeft: 15,
    width: 945,
    marginTop: 10,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#1976d2',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
      },
    },
  },
  fieldShort: {
    marginLeft: 15,
    marginTop: 10,
  },
  radioSet: {
    marginTop: 15,
    marginLeft: 15,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
  droparea: {
    width: 940,
    height: 200,
    marginTop: 10,
    borderWidth: 2,
    borderColor: 'rgb(102,102,102)',
    borderStyle: 'dashed',
    borderRadius: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photoContainer: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'column',
  },
  imgPreview: {
    height: 'auto',
    width: 'auto',
    maxWidth: 300,
    maxHeight: 300,
  },
  checkboxes: {
    marginLeft: 15,
    marginRight: 15,
  },
});

const Styled = withStyles(styles)(User);
export default connect(
  state => ({
    centers: state.centers,
    users: state.users,
  }),
  { updateUser, createUser }
)(Styled);
